import Swiper from "swiper";
import downloadList from "@/views/index/data/downloadList";
import fixedBtns from '@/views/index/data/fiexdBtns';
import methods from "../methods/methods";
import {getUrlKey,isMobile} from "@/util/util";

export default {
    data() {
        return {
            indexInfo: {
                hot_topic: {
                    title: ''
                }
            },
            p: 1,
            indexNum: 1,            //设置变量判断索引值0是否为第一次输出
            activity: [],
            headline: [],
            top_banner: [],
            bottom_banner: [],
            hot_star: [],
            downloadList,
            fixedBtns,
            show_fixed: true,
            downloadInfo: {},
            download_img: '',
            select_btn: 0,
            selected: 0,
            activeIndex: 0,
            selected_small: 0,
            showMore: true,
            banner_name: '',
            timer: '',
            is_big: false,
            photo: [],
            initial_index: 0,
        }
    },

    created() {

        if (isMobile()) {
            window.location.href = this.$link;
        }

        let code = getUrlKey('code',location.href);
        let state = getUrlKey('state',location.href);
        if(!this.$isLogin()) {
            if(code) {
                if(state === 'wechat') {
                    this.wechatLogin(code);
                }else if(state === 'qq') {
                    this.qqLogin(code)
                }
            }
        }

        this.getDownloadInfo();

        this.getIndexInfo();
    },

    beforeDestroy() {
        if(this.timer) {
            clearTimeout(this.timer)
        }
    },

    mounted() {

        this.initSwiper()

    },

    methods,
}
